import { render, staticRenderFns } from "./details.vue?vue&type=template&id=182e6bb6&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=182e6bb6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182e6bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('182e6bb6')) {
      api.createRecord('182e6bb6', component.options)
    } else {
      api.reload('182e6bb6', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=182e6bb6&scoped=true", function () {
      api.rerender('182e6bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/device-identity-auth/equipment-labels/details.vue"
export default component.exports